// product namespace — ProductPage.vue, components/product/*, ProductCard.vue
export default {
  en: {
    breadcrumb: {
      catalog: 'Catalog',
    },
    share: {
      copied: 'Link copied',
      failed: 'Could not copy the link',
      copyLink: 'Copy link',
    },
    gallery: {
      label: 'Product images',
      position: 'Image {current} of {total}',
      previous: 'Previous image',
      next: 'Next image',
      show: 'Show image {number}',
      enlarge: 'View full screen',
      lightbox: '{name} — images',
    },
    shareAriaLabel: 'Share',
    region: {
      global: 'Global',
    },
    by: 'by {names}',
    metacritic: 'Metacritic {score}',
    chips: {
      releases: 'Out {date}',
    },
    purchase: {
      label: 'Buy',
      buyNow: 'Buy now',
      checkingAvailability: 'Checking availability…',
      addToCart: 'Add to cart',
      addedViewCart: 'Added — view cart →',
      alreadyInCart: 'Already in cart — view cart →',
      cartLimit: 'Cart limit reached ({limit} per order)',
      refundNote: '14-day refund guarantee on unrevealed keys',
    },
    unavailable: {
      delistedTitle: 'No longer available',
      delistedBody: 'This product has been removed from our catalog and can\'t be purchased.',
      outOfStockTitle: 'Currently out of stock',
      outOfStockBody: 'Every seller is sold out. Save it to your favourites and check back later.',
    },
    offers: {
      merchant: 'Seller',
      stock: 'Stock',
      price: 'Price',
      addFrom: 'Add offer from {merchant} to cart',
      heading: 'Offers from other sellers',
      anonymous: 'Anonymous merchant',
      inStock: '{qty} in stock',
      lowestBadge: 'Lowest',
      addButton: 'Add',
    },
    activation: {
      heading: 'How to activate',
      stepLabel: 'Step {number}.',
      steam: [
        'Launch the Steam client software and log into your account.',
        'Click the "Games" menu at the top of the client.',
        'Choose "Activate a Product on Steam..."',
        'Follow the onscreen instructions to complete the process.',
      ],
      gog: [
        'Open the GOG GALAXY client or visit gog.com and log into your account.',
        'Click on your username in the top-right corner.',
        'Choose "Redeem a code" from the dropdown menu.',
        'Enter your key and follow the prompts to add the game to your library.',
      ],
      epic: [
        'Launch the Epic Games Launcher and log in.',
        'Click your account name in the top-right and open Account.',
        'Find the "Redeem Code" option in the menu.',
        'Paste your key and confirm to add the game to your library.',
      ],
      ea: [
        'Launch the EA app and sign in to your EA account.',
        'Open the menu and choose "Redeem product code".',
        'Enter your activation key in the dialog.',
        'Confirm to add the title to your EA library.',
      ],
      xbox: [
        'Open the Microsoft Store or Xbox app and sign in.',
        'Open your profile menu in the top-right corner.',
        'Select "Redeem code" from the menu.',
        'Enter the 25-character code and confirm.',
      ],
      // Account listings (Product.kind ACCOUNT): login details, not a key.
      accountHeading: 'How to use your account',
      account: [
        'This is a ready-made account with the product already on it — there is no key to redeem.',
        'After purchase, open the order in your account and reveal the login details.',
        'Sign in with those details on the platform or service the product is for.',
        'Follow any extra instructions delivered with the login details, such as how to secure the account.',
      ],
    },
    about: {
      heading: 'About this game',
      showMore: 'Show more',
      showLess: 'Show less',
      noDescription: 'No description available for this title.',
    },
    details: {
      heading: 'Game details',
      publisher: 'Publisher',
      languages: 'Languages',
    },
    related: {
      heading: 'You might also like',
    },
    languagesMore: '+ {count} more',
    card: {
      preorder: 'Pre-order',
      pegi: 'PEGI {badge}',
      quickView: 'Quick view: {name}',
      quickViewShort: 'Quick view',
      ageRating: 'Age rating',
      offers: '{count} offers',
      addToFavorites: 'Add to favorites',
      removeFromFavorites: 'Remove from favorites',
      noLongerAvailable: 'No longer available',
      outOfStock: 'Out of stock',
      instant: 'Instant',
      from: 'from',
      addToCart: 'Add to cart',
      added: 'Added to cart',
      inCart: 'Already in cart',
      cartFull: 'Cart is full',
    },
    error: {
      browseCatalog: 'Browse catalog',
      notFound: 'Not found',
      loadFailed: 'Failed to load product',
    },
  },
  cs: {
    breadcrumb: {
      catalog: 'Katalog',
    },
    share: {
      copied: 'Odkaz zkopírován',
      failed: 'Odkaz se nepodařilo zkopírovat',
      copyLink: 'Kopírovat odkaz',
    },
    gallery: {
      label: 'Obrázky produktu',
      position: 'Obrázek {current} z {total}',
      previous: 'Předchozí obrázek',
      next: 'Další obrázek',
      show: 'Zobrazit obrázek {number}',
      enlarge: 'Zobrazit na celou obrazovku',
      lightbox: '{name} — obrázky',
    },
    shareAriaLabel: 'Sdílet',
    region: {
      global: 'Globálně',
    },
    by: 'od {names}',
    metacritic: 'Metacritic {score}',
    chips: {
      releases: 'Vychází {date}',
    },
    purchase: {
      label: 'Nákup',
      buyNow: 'Koupit hned',
      checkingAvailability: 'Ověřování dostupnosti…',
      addToCart: 'Přidat do košíku',
      addedViewCart: 'Přidáno — zobrazit košík →',
      alreadyInCart: 'Již v košíku — zobrazit košík →',
      cartLimit: 'Limit košíku dosažen ({limit} na objednávku)',
      refundNote: '14denní záruka vrácení peněz za neodhalené klíče',
    },
    unavailable: {
      delistedTitle: 'Již nedostupné',
      delistedBody: 'Tento produkt byl odebrán z našeho katalogu a nelze jej zakoupit.',
      outOfStockTitle: 'Momentálně vyprodáno',
      outOfStockBody: 'Všichni prodejci jsou vyprodáni. Uložte si hru do oblíbených a zkuste to později.',
    },
    offers: {
      merchant: 'Prodejce',
      stock: 'Sklad',
      price: 'Cena',
      addFrom: 'Přidat nabídku od {merchant} do košíku',
      heading: 'Nabídky od jiných prodejců',
      anonymous: 'Anonymní prodejce',
      inStock: '{qty} skladem',
      lowestBadge: 'Nejnižší',
      addButton: 'Přidat',
    },
    activation: {
      heading: 'Jak aktivovat',
      stepLabel: 'Krok {number}.',
      steam: [
        'Spusťte klienta Steam a přihlaste se ke svému účtu.',
        'Klikněte na nabídku „Hry" v horní části klienta.',
        'Zvolte „Aktivovat produkt na Steamu…"',
        'Postupujte podle pokynů na obrazovce.',
      ],
      gog: [
        'Otevřete klienta GOG GALAXY nebo navštivte gog.com a přihlaste se ke svému účtu.',
        'Klikněte na své uživatelské jméno v pravém horním rohu.',
        'Z rozbalovací nabídky zvolte „Uplatnit kód".',
        'Zadejte klíč a postupujte podle pokynů k přidání hry do vaší knihovny.',
      ],
      epic: [
        'Spusťte spouštěč Epic Games a přihlaste se.',
        'Klikněte na své jméno účtu vpravo nahoře a otevřete Účet.',
        'V nabídce vyhledejte možnost „Uplatnit kód".',
        'Vložte klíč a potvrďte přidání hry do vaší knihovny.',
      ],
      ea: [
        'Spusťte aplikaci EA a přihlaste se ke svému EA účtu.',
        'Otevřete nabídku a zvolte „Uplatnit produktový kód".',
        'Do dialogu zadejte aktivační klíč.',
        'Potvrďte přidání titulu do vaší EA knihovny.',
      ],
      xbox: [
        'Otevřete Microsoft Store nebo aplikaci Xbox a přihlaste se.',
        'Otevřete menu svého profilu v pravém horním rohu.',
        'Vyberte „Uplatnit kód" z nabídky.',
        'Zadejte 25místný kód a potvrďte.',
      ],
      accountHeading: 'Jak používat účet',
      account: [
        'Jde o hotový účet, na kterém už produkt je — žádný klíč se neaktivuje.',
        'Po nákupu otevřete objednávku ve svém účtu a zobrazte přihlašovací údaje.',
        'Přihlaste se těmito údaji na platformě nebo ve službě, pro kterou je produkt určen.',
        'Řiďte se případnými dalšími pokyny dodanými s přihlašovacími údaji, například jak účet zabezpečit.',
      ],
    },
    about: {
      heading: 'O této hře',
      showMore: 'Zobrazit více',
      showLess: 'Zobrazit méně',
      noDescription: 'Pro tento titul není k dispozici popis.',
    },
    details: {
      heading: 'Podrobnosti o hře',
      publisher: 'Vydavatel',
      languages: 'Jazyky',
    },
    related: {
      heading: 'Mohlo by vás zajímat',
    },
    languagesMore: '+ {count} dalších',
    card: {
      preorder: 'Předobjednávka',
      pegi: 'PEGI {badge}',
      quickView: 'Rychlý náhled: {name}',
      quickViewShort: 'Rychlý náhled',
      ageRating: 'Věkové hodnocení',
      offers: '{count} nabídek',
      addToFavorites: 'Přidat do oblíbených',
      removeFromFavorites: 'Odebrat z oblíbených',
      noLongerAvailable: 'Již nedostupné',
      outOfStock: 'Vyprodáno',
      instant: 'Ihned',
      from: 'od',
      addToCart: 'Přidat do košíku',
      added: 'Přidáno do košíku',
      inCart: 'Již v košíku',
      cartFull: 'Košík je plný',
    },
    error: {
      browseCatalog: 'Procházet katalog',
      notFound: 'Nenalezeno',
      loadFailed: 'Nepodařilo se načíst produkt',
    },
  },
};
